/* prettier-ignore-start */
/* tslint:disable */
/* eslint-disable */

import request from '@/utils/request/index';

/**
 * 接口 [用户音频素材列表] 的 **请求函数**
 *
 * @分类 [AI素材相关]
 * @请求头 `GET /userAiMaterial/voice/list`
 */
export const getUserVoiceList = <
  OT extends ToolTypes.GetOptionsType<typeof request> = { returnData: true }
>(
  data?: ToolTypes.GetRequestType<API.GetUserVoiceListRequest>,
  options?: OT
) =>
  request<ToolTypes.GetResponseType<API.GetUserVoiceListResponse, OT>>(
    '/userAiMaterial/voice/list',
    'POST',
    data,
    options
  );

/**
 * 接口 [用户视频素材列表] 的 **请求函数**
 *
 * @分类 [AI素材相关]
 * @请求头 `GET /userAiMaterial/video/list`
 */
export const getUserVideoList = <
  OT extends ToolTypes.GetOptionsType<typeof request> = { returnData: true }
>(
  data?: ToolTypes.GetRequestType<API.GetUserVideoListRequest>,
  options?: OT
) =>
  request<ToolTypes.GetResponseType<API.GetUserVideoListResponse, OT>>(
    '/userAiMaterial/video/list',
    'POST',
    data,
    options
  );

/**
 * 接口 [文件上传] 的 **请求函数**
 *
 * @分类 [工具类]
 * @请求头 `POST /util/upload`
 */
export const uploadFile = <
  OT extends ToolTypes.GetOptionsType<typeof request> = { returnData: true }
>(
  data: ToolTypes.GetRequestType<API.UploadFileRequest>,
  options?: OT
) =>
  request<ToolTypes.GetResponseType<API.UploadFileResponse, OT>>(
    '/util/upload',
    'POST',
    data,
    options
  );

/**
 * 接口 [用户视频上传] 的 **请求函数**
 *
 * @分类 [AI素材相关]
 * @请求头 `POST /userAiMaterial/video/upload`
 */
export const uploadUserVideo = <
  OT extends ToolTypes.GetOptionsType<typeof request> = { returnData: true }
>(
  data: ToolTypes.GetRequestType<API.UserVideoUploadRequest>,
  options?: OT
) =>
  request<ToolTypes.GetResponseType<API.UserVideoUploadResponse, OT>>(
    '/userAiMaterial/video/upload',
    'POST',
    data,
    options
  );

/**
 * 接口 [用户音频克隆训练] 的 **请求函数**
 *
 * @分类 [AI素材相关]
 * @请求头 `POST /userAiMaterial/voice/train`
 */
export const trainUserVoice = <
  OT extends ToolTypes.GetOptionsType<typeof request> = { returnData: true }
>(
  data: ToolTypes.GetRequestType<API.UserVoiceCloneTrainRequest>,
  options?: OT
) =>
  request<ToolTypes.GetResponseType<API.UserVoiceCloneTrainResponse, OT>>(
    '/userAiMaterial/voice/train',
    'POST',
    data,
    options
  );

/**
 * 接口 [团购详情] 的 **请求函数**
 *
 * @分类 [团购相关]
 * @请求头 `POST /group/detail`
 */
export const getGroupDetail = <
  OT extends ToolTypes.GetOptionsType<typeof request> = { returnData: true }
>(
  data: ToolTypes.GetRequestType<API.GroupDetailRequest>,
  options?: OT
) =>
  request<ToolTypes.GetResponseType<API.GroupDetailResponse, OT>>(
    '/group/detail',
    'POST',
    data,
    options
  );

/**
 * 接口 [AI内容生成] 的 **请求函数**
 *
 * @分类 [团购相关]
 * @请求头 `POST /group/block/aiGenerate`
 */
export const aiGenerate = <
  OT extends ToolTypes.GetOptionsType<typeof request> = { returnData: true }
>(
  data: ToolTypes.GetRequestType<API.AiGenerateRequest>,
  options?: OT
) =>
  request<ToolTypes.GetResponseType<API.AiGenerateResponse, OT>>(
    '/group/block/aiGenerate',
    'POST',
    data,
    options
  );

/**
 * 接口 [修改团购] 的 **请求函数**
 *
 * @分类 [团购相关]
 * @请求头 `POST /group/modify`
 */
export const modifyGroup = <
  OT extends ToolTypes.GetOptionsType<typeof request> = { returnData: true }
>(
  data: ToolTypes.GetRequestType<API.ModifyGroupRequest>,
  options?: OT
) =>
  request<ToolTypes.GetResponseType<API.ModifyGroupResponse, OT>>(
    '/group/modify',
    'POST',
    data,
    options
  );

/**
 * 接口 [删除团购] 的 **请求函数**
 *
 * @分类 [团购相关]
 * @请求头 `POST /group/delete`
 */
export const deleteGroup = <
  OT extends ToolTypes.GetOptionsType<typeof request> = { returnData: true }
>(
  data: ToolTypes.GetRequestType<API.DeleteGroupRequest>,
  options?: OT
) =>
  request<ToolTypes.GetResponseType<API.DeleteGroupResponse, OT>>(
    '/group/delete',
    'POST',
    data,
    options
  );

/**
 * 接口 [获取AI生成内容] 的 **请求函数**
 *
 * @分类 [团购相关]
 * @请求头 `POST /group/block/getAiGenerateContent`
 */
export const getAiGenerateContent = <
  OT extends ToolTypes.GetOptionsType<typeof request> = { returnData: true }
>(
  data: ToolTypes.GetRequestType<API.GetAiGenerateContentRequest>,
  options?: OT
) =>
  request<ToolTypes.GetResponseType<API.GetAiGenerateContentResponse, OT>>(
    '/group/block/getAiGenerateContent',
    'POST',
    data,
    options
  );

/**
 * 接口 [删除用户视频] 的 **请求函数**
 *
 * @分类 [AI素材相关]
 * @请求头 `POST /userAiMaterial/video/del`
 */
export const deleteUserVideo = <
  OT extends ToolTypes.GetOptionsType<typeof request> = { returnData: true }
>(
  data: ToolTypes.GetRequestType<API.DeleteUserVideoRequest>,
  options?: OT
) =>
  request<ToolTypes.GetResponseType<API.DeleteUserVideoResponse, OT>>(
    '/userAiMaterial/video/del',
    'POST',
    data,
    options
  );

/**
 * 接口 [删除用户音色] 的 **请求函数**
 *
 * @分类 [AI素材相关]
 * @请求头 `POST /userAiMaterial/voice/del`
 */
export const deleteUserVoice = <
  OT extends ToolTypes.GetOptionsType<typeof request> = { returnData: true }
>(
  data: { userVoiceId?: number },
  options?: OT
) =>
  request<ToolTypes.GetResponseType<{ code?: number; data?: null; message?: string }, OT>>(
    '/userAiMaterial/voice/del',
    'POST',
    data,
    options
  );

/**
 * 接口 [更新音色标题] 的 **请求函数**
 *
 * @分类 [AI素材相关]
 * @请求头 `POST /userAiMaterial/voice/updateTitle`
 */
export const updateUserVoiceTitle = <
  OT extends ToolTypes.GetOptionsType<typeof request> = { returnData: true }
>(
  data: { id?: number; title?: string },
  options?: OT
) =>
  request<ToolTypes.GetResponseType<{ code?: number; data?: null; message?: string }, OT>>(
    '/userAiMaterial/voice/updateTitle',
    'POST',
    data,
    options
  );

/**
 * 接口 [更新视频标题] 的 **请求函数**
 *
 * @分类 [AI素材相关]
 * @请求头 `POST /userAiMaterial/video/updateTitle`
 */
export const updateUserVideoTitle = <
  OT extends ToolTypes.GetOptionsType<typeof request> = { returnData: true }
>(
  data: { id?: number; title?: string },
  options?: OT
) =>
  request<ToolTypes.GetResponseType<{ code?: number; data?: null; message?: string }, OT>>(
    '/userAiMaterial/video/updateTitle',
    'POST',
    data,
    options
  );

/* prettier-ignore-end */
